import type { WidgetOrderPageData } from '../types';
import type { AccountData, Currency, OrderDetailsRequestData, OrderPageData } from '../../../api';

/** Where a line's money came from — one member per price-object type in the engine. */
export enum PriceLineType {
  QUANTITY = 'QUANTITY', // number price object
  OPTION = 'OPTION', // enum price object
  TOGGLE = 'TOGGLE', // bool price object
  THRESHOLD = 'THRESHOLD', // gt price object
  TICKETS = 'TICKETS', // multiple_tickets_price
  SURCHARGE = 'SURCHARGE', // weekend/holiday plugin, applied to the summed total
}

export type PriceLine = {
  /** Which order detail or custom detail the charge came from. Often an ObjectId — map before rendering. */
  orderDetailLabel: string;
  amount: number;
  type: PriceLineType;
};

export type DepositInfo = { amount: number; currency: Currency };

export type PriceQuote = {
  /** One per entry in orderPage.price, zero amounts included, plus the surcharge when it applies. */
  lines: PriceLine[];
  total: number;
  deposit: DepositInfo | null;
};

/** Pricing only reads the date — it decides whether the weekend multiplier applies. */
export type PricingDate = { date?: string | null };

export type PriceQuoteProps = {
  orderPage: OrderPageData;
  details: OrderDetailsRequestData;
  dateDetails: PricingDate | undefined;
  account: AccountData | undefined;
  /** Gift card bought with weekend validity: charge the multiplier whatever date is picked. */
  forceWeekendAddition?: boolean;
};

export type DepositInfoProps = {
  /** The union, not just a bookable page — the pass flow shares the payment and save-order paths. */
  widgetOrderPageData: WidgetOrderPageData;
  details: OrderDetailsRequestData;
  dateDetails: PricingDate | undefined;
  account: AccountData;
};
